module.exports = __webpack_public_path__ + "9750a53170d543f255c5a9e61d8037fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-detail-img1.jpg
// module id = 225
// module chunks = 24